{
  "toasts": {
    "logoUpdated": "¡Logo actualizado correctamente!",
    "logoUploadError": "Error al subir el logo",
    "logoRemoved": "Logo eliminado",
    "logoRemoveError": "Error al eliminar el logo",
    "bannerCreated": "¡Banner creado correctamente!",
    "bannerCreateError": "Error al crear el banner",
    "bannerUpdated": "¡Banner actualizado!",
    "bannerUpdateError": "Error al actualizar el banner",
    "bannerDeleted": "¡Banner eliminado!",
    "bannerDeleteError": "Error al eliminar el banner",
    "menuItemCreated": "¡Elemento de menú creado!",
    "menuItemCreateError": "Error al crear el elemento de menú",
    "menuItemUpdated": "¡Elemento de menú actualizado!",
    "menuItemUpdateError": "Error al actualizar el elemento de menú",
    "menuItemDeleted": "¡Elemento de menú eliminado!",
    "menuItemDeleteError": "Error al eliminar el elemento de menú",
    "settingsUpdated": "¡Configuración actualizada!",
    "settingsUpdateError": "Error al actualizar la configuración"
  },
  "branding": {
    "toasts": {
      "saveError": "No se pudo guardar.",
      "saved": "Identidad actualizada. Tus alumnos ya ven el cambio.",
      "reset": "Identidad restablecida a la predeterminada."
    },
    "loading": "Cargando…",
    "title": "Identidad visual",
    "subtitle": "Cómo ven tus alumnos tu área de miembros.",
    "logo": {
      "title": "Logo",
      "description": "Aparece en la parte superior del menú y en la pantalla de acceso. JPG, PNG, SVG o WEBP, hasta 2 MB."
    },
    "banner": {
      "title": "Imagen de acceso",
      "description": "Ocupa el panel junto al formulario de inicio de sesión. JPG, PNG o WEBP, hasta 5 MB. Sin imagen, aparece la marca de Xtreed."
    },
    "favicon": {
      "title": "Favicon",
      "description": "Icono de la pestaña del navegador. ICO, PNG o SVG, hasta 1 MB."
    },
    "colors": {
      "title": "Colores",
      "description": "El color principal tiñe los botones, enlaces y elementos destacados del área.",
      "primary": "Color principal",
      "secondary": "Color secundario",
      "hex": "{{label}} en hexadecimal"
    },
    "texts": {
      "title": "Textos",
      "welcome": "Saludo de bienvenida",
      "welcomePlaceholder": "Bienvenido",
      "footer": "Texto del pie de página",
      "footerPlaceholder": "© Tu escuela"
    },
    "save": "Guardar",
    "resetConfirm": "Esto borra el logo, la imagen de acceso, el favicon y los colores. ¿Continuar?",
    "reset": "Restablecer valores predeterminados",
    "image": {
      "uploaded": "Se ha actualizado: {{name}}.",
      "uploadError": "No se pudo subir: {{name}}.",
      "uploading": "Subiendo…",
      "choose": "Elegir archivo",
      "preview": "Vista previa: {{name}}",
      "empty": "No se ha subido ningún archivo"
    },
    "theme": {
      "title": "Tema",
      "description": "Define si el área del alumno es clara, oscura o si cada alumno elige.",
      "modes": {
        "STUDENT_CHOICE": "El alumno elige (claro u oscuro)",
        "LIGHT": "Siempre claro",
        "DARK": "Siempre oscuro"
      }
    }
  },
  "customizationForm": {
    "validation": {
      "invalidHex": "El color debe ser un hexadecimal válido",
      "welcomeRequired": "El texto de bienvenida es obligatorio",
      "footerRequired": "El texto del pie de página es obligatorio"
    },
    "tabs": {
      "branding": "Marca",
      "colors": "Colores",
      "content": "Contenido"
    },
    "uploading": "Subiendo...",
    "loaded": "Cargado",
    "loadedFeminine": "Cargada",
    "logo": {
      "title": "Logo",
      "description": "Sube el logo de la plataforma (JPG, PNG, SVG - máx. 2 MB)",
      "url": "URL del logo",
      "upload": "Subir logo",
      "preview": "Vista previa del logo"
    },
    "banner": {
      "title": "Imagen de acceso",
      "description": "Ocupa el panel junto al formulario de inicio de sesión (JPG, PNG o WEBP, máx. 5 MB). Sin imagen, aparece la marca de Xtreed.",
      "url": "URL de la imagen",
      "upload": "Subir imagen",
      "preview": "Vista previa de la imagen de acceso"
    },
    "favicon": {
      "title": "Favicon",
      "description": "Icono que aparece en la pestaña del navegador (ICO, PNG - máx. 1 MB)",
      "url": "URL del favicon",
      "upload": "Subir favicon",
      "preview": "Vista previa del favicon"
    },
    "colors": {
      "title": "Esquema de colores",
      "description": "Define los colores principales de la plataforma",
      "primary": "Color primario",
      "primaryHint": "Color principal de los botones y elementos activos",
      "secondary": "Color secundario",
      "secondaryHint": "Color para acentos y elementos secundarios",
      "preview": "Vista previa de los colores",
      "primaryShort": "Primario",
      "secondaryShort": "Secundario"
    },
    "texts": {
      "title": "Textos personalizados",
      "description": "Personaliza los textos que aparecen en la plataforma",
      "welcome": "Texto de bienvenida",
      "welcomePlaceholder": "Bienvenido a Xtreed",
      "welcomeHint": "Texto que se muestra en la página de inicio",
      "footer": "Texto del pie de página",
      "footerPlaceholder": "© 2024 Xtreed. Todos los derechos reservados.",
      "footerHint": "Texto que se muestra en el pie de todas las páginas"
    },
    "actions": {
      "reset": "Restablecer valores predeterminados",
      "saving": "Guardando...",
      "save": "Guardar cambios"
    },
    "preview": {
      "title": "Vista previa en tiempo real",
      "description": "Mira cómo quedará el aspecto de la plataforma",
      "nav": {
        "courses": "Cursos",
        "tracks": "Rutas",
        "profile": "Perfil"
      },
      "heroSubtitle": "Aprende las tecnologías más modernas del mercado",
      "start": "Empezar ahora",
      "learnMore": "Más información",
      "featuredCourse": "Curso destacado",
      "sampleCourse": "React de cero a profesional",
      "popularTrack": "Ruta popular",
      "platformStudent": "Alumno de la plataforma"
    },
    "palette": {
      "title": "Paleta de colores"
    }
  },
  "cms": {
    "positions": {
      "home": "Inicio",
      "sidebar": "Barra lateral",
      "header": "Cabecera"
    },
    "title": "Personalización",
    "subtitle": "Gestiona los banners, menús y secciones de la plataforma",
    "tabs": {
      "banners": "Banners",
      "menu": "Menú",
      "sections": "Secciones del inicio",
      "support": "Soporte"
    },
    "actions": {
      "delete": "Eliminar",
      "activate": "Activar",
      "deactivate": "Desactivar"
    },
    "status": {
      "inactive": "Inactivo"
    },
    "banners": {
      "title": "Banners",
      "description": "Los banners se muestran en el panel del alumno. Varios banners crean un carrusel automático.",
      "new": "Nuevo banner",
      "create": "Crear banner",
      "fallbackTitle": "Banner",
      "untitled": "Banner sin título",
      "noLink": "Sin enlace de destino",
      "emptyTitle": "Ningún banner",
      "emptyDescription": "Añade banners para mostrarlos en el panel de los alumnos",
      "deleteTitle": "Eliminar banner",
      "deleteDescription": "¿Seguro que quieres eliminar este banner?"
    },
    "menu": {
      "title": "Menú personalizado",
      "description": "Añade enlaces personalizados al menú lateral del alumno",
      "new": "Nuevo elemento",
      "create": "Crear elemento",
      "external": "Externo",
      "noUrl": "Sin URL",
      "emptyTitle": "Ningún elemento de menú",
      "emptyDescription": "Añade enlaces al menú lateral de los alumnos",
      "preview": "Vista previa del menú",
      "previewLinks": "Enlaces",
      "deleteTitle": "Eliminar elemento de menú",
      "deleteDescription": "¿Seguro que quieres eliminar este elemento de menú?"
    },
    "sections": {
      "description": "Organiza los cursos en secciones en la página de inicio de los alumnos"
    },
    "support": {
      "title": "Soporte por WhatsApp",
      "description": "Configura el botón de soporte que ven los alumnos",
      "cardTitle": "WhatsApp de soporte",
      "active": "Soporte activo",
      "inactive": "Soporte desactivado",
      "number": "Número de WhatsApp",
      "numberPlaceholder": "34600000000",
      "numberHint": "Formato: prefijo del país + número (p. ej.: 34600000000)",
      "message": "Mensaje automático",
      "messagePlaceholder": "¡Hola! Necesito ayuda con...",
      "messageHint": "Mensaje precargado al abrir WhatsApp",
      "saving": "Guardando...",
      "save": "Guardar configuración",
      "activeDescription": "El botón de WhatsApp aparecerá en la esquina inferior derecha para los alumnos.",
      "inactiveDescription": "Activa el soporte para mostrar el botón de WhatsApp a los alumnos."
    }
  }
}
